export default {
    data: () => ({
        orderDunningColumns: [
            {
                label: "lending number/ID",
                field: "id",
                sortable: true,
                required: true
            }, {
                label: "lead number/ID",
                field: "lead_id",
                required: true,
                sortable: true
            }, {
                label: "phone",
                field: "phone",
                sortable: true,
                required: true
            }, {
                label: "nif",
                field: "nif",
                required: true
            }, {
                label: "email",
                field: "email",
                sortable: true,
                required: true
            }, {
                label: "device",
                field: "device",
                required: true
            }, {
                label: "lending start date",
                field: "start_lending_at",
                required: true
            }, {
                label: "days count",
                field: "days_count",
                sortable: true,
                required: true
            }, {
                label: "SMS #1",
                field: "dunning_sms_1",
                required: true,
            },{
                label: "SMS #2",
                field: "dunning_sms_2",
                required: true,
            }, {
                label: "Email #1",
                field: "dunning_email_1",
                required: true,
            },{
                label: "Email #2",
                field: "dunning_email_2",
                required: true,
            }, {
                label: "comments",
                field: "last_iqos_comment",
                required: true,
            }


        ]
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/orderDunningColumns.js